<div class="container mt-card" #origin>
    <div class="form-card">

        <!-- Header -->
        <div class="card-header">
            <div class="header-accent"></div>
            <div class="header-content">
                <div class="mode-badge" [ngClass]="mode.toLowerCase()">{{ mode || 'create' }}</div>
                <h2 class="card-title">{{ text }} User</h2>
                <p class="card-subtitle" *ngIf="text !== 'View'">
                    Fill in the details below to {{ text | lowercase }} the user.
                </p>
            </div>
        </div>

        <!-- Form Body -->
        <form class="card-body" [class.disabled-form]="disableAll" (ngSubmit)="onSubmit()">

            <div class="form-row">
                <div class="field-group">
                    <label class="field-label" for="name">
                        Full Name
                    </label>
                    <input id="name" type="text" class="field-input" [(ngModel)]="user.name" name="name"
                        [disabled]="disableAll" placeholder="e.g. Jane Doe" />
                </div>

                <div class="field-group">
                    <label class="field-label" for="username">
                        Username
                    </label>
                    <input id="username" type="text" class="field-input" [(ngModel)]="user.username" name="username"
                        [disabled]="disableAll" placeholder="e.g. janedoe" />
                </div>
            </div>

            <div class="form-row">
                <div class="field-group">
                    <label class="field-label" for="email">
                        Email Address
                    </label>
                    <input id="email" type="email" class="field-input" [(ngModel)]="user.emailAddress"
                        name="emailAddress" [disabled]="disableAll" placeholder="jane@example.com" />
                </div>

                <!-- <div class="field-group">
                    <label class="field-label" for="company">
                         Default Company
                    </label>
                    <input id="company" type="text" class="field-input" [(ngModel)]="user.defaultCompany"
                        name="defaultCompany" [disabled]="disableAll" placeholder="Company name" />
                </div> -->
            </div>

            <div class="form-row" *ngIf="text !== 'View' && text === 'Update'">
                <div class="field-group full-width">
                    <label class="field-label" for="password">
                        Password
                    </label>
                    <input id="password" type="password" class="field-input" [(ngModel)]="user.password" name="password"
                        [disabled]="disableAll" placeholder="••••••••••••" />
                </div>
            </div>

            <div class="form-row" *ngIf="this.text === 'Update'">
                <div class="field-group full-width">
                    <div class="toggle-row">
                        <div class="toggle-info">
                            <span class="toggle-label">Force Password Change on Next Login</span>
                            <span class="toggle-hint">User will be prompted to update their password</span>
                        </div>
                        <label class="toggle-switch">
                            <input type="checkbox" [(ngModel)]="user.forceChangePassword" name="forceChangePassword"
                                [disabled]="disableAll" />
                            <span class="toggle-track">
                                <span class="toggle-thumb"></span>
                            </span>
                        </label>
                    </div>
                </div>
            </div>

            <div class="card-actions" *ngIf="text !== 'View'">
                <button type="button" class="btn-ghost" (click)="this.window$.history.back()">
                    Cancel
                </button>
                <button type="submit" class="btn-primary">
                    {{ text }} User
                </button>
            </div>

            <div class="card-actions" *ngIf="text === 'View'">
                <button type="button" class="btn-primary" (click)="this.text = 'Update'; this.disableAll = false">
                    Edit User
                </button>
            </div>

        </form>

    </div>
</div>